function Footer() {
    return (
        <footer id="main-footer">
            <div className="line">&copy; 2019 HyperG. All Rights Reserved.</div>
        </footer>
    );
}
export default Footer;